
import {
  createModule,
  HttpClient,
} from 'yoshi-flow-bm-runtime';
import { createBILogger } from '/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/target/generated/bi/createBILogger';
import type { ModuleLite } from 'yoshi-flow-bm-runtime/common';

createModule({
  module: {
    module: {"moduleId":"HOME","config":{"routeNamespace":"home","moduleId":"HOME","appDefId":"a7597ab5-1ed4-458f-a5c1-5884d5e14281","isCoreService":true,"moduleBundleName":"business-dashboard-module","translations":{"enabled":true,"suspense":true},"experiments":{"scopes":["business-dashboard"]},"sentry":{"DSN":"https://710d8d656919469c957b13640fdd3239@sentry.wixpress.com/591","id":"710d8d656919469c957b13640fdd3239","projectName":"business-dashboard-app","teamName":"wos-1"},"topology":{"businessDashboardWidgetsPanelTranslations":{"artifactId":"com.wixpress.business-dashboard-widgets-panel-translations"},"staticsUrl":{"artifactId":"com.wixpress.business-dashboard-app"}},"bi":"@wix/bi-logger-new-dash-platform","fedops":{"phasesConfig":"SEND_START_AND_FINISH"},"cdn":{"port":3202}},"fedopsPath":"/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/fedops.json"} as ModuleLite,
    
    
  },
  pages: [
    
  {
    component: {"componentId":"business-dashboard","componentType":"page","componentName":"business-dashboard"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "business-dashboard" */ './pages/index')).default,
    
    resolveHook: require('/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/pages/index.module').resolve,
    filesHook: require('/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/pages/index.module').files,
  },
  ],
  exportedComponents: [
    
  {
    component: {"componentId":"dashboard-widgets-panel","componentType":"exported-component"},
    loadReactComponent: async () => (await import(/* webpackChunkName: "dashboard-widgets-panel" */ './exported-components/active-dashboard-widgets-panel/active-dashboard-widgets-panel')).default,
    asyncMessagesLoader: (locale) => import(`/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/exported-components/active-dashboard-widgets-panel/locale/messages_${locale}.json`),
    resolveHook: require('/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/exported-components/active-dashboard-widgets-panel/active-dashboard-widgets-panel.module').resolve,
    filesHook: require('/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/exported-components/active-dashboard-widgets-panel/active-dashboard-widgets-panel.module').files,
  },
  ],
  useEssentials: true,
  methods: [
    
  {
    method: {"methodId":"business-dashboard-app.registerWidget"},
    fn: () => require('/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/methods/register-widget').default,
  },
  ],
  optionalDeps: {
    HttpClient,
    loadOptionalFlowAPIDeps: async () => ({}),
    asyncMessagesLoader: (locale: string) => import(`/home/builduser/work/dd1a7eca76032f02/packages/business-dashboard-app/src/assets/locale/messages_${locale}.json`),
    createBILogger,
  },
});